import { Component, Input } from '@angular/core';
import { RepositoryService } from '../../services/repository/repository.service';
import Utils from '../../../utils';
import Article from '../../../models/Article';
import { PreorderType } from '../../../enums/PreorderType';
import { OrderType } from '../../../enums/OrderType';

@Component({
	selector: 'app-item-selectable-article',
	templateUrl: './item-selectable-article.component.html',
	styleUrls: ['item-selectable-article.component.scss'],
})
export class ItemSelectableArticleComponent {
	@Input() article: Article;
	@Input() selected: number;
	@Input() preorderType: PreorderType;
	utils = Utils;
	currency: string;

	constructor(public repository: RepositoryService) {
		this.currency = repository._order ? repository._order.currency : null;
		this.repository.order.subscribe(order => (this.currency = order ? order.currency : null));
	}

	get price(): number {
		return Utils.getPrice(this.article, OrderType.STANDARD, this.preorderType);
	}
}
